import { Component, Input, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditContactComponent } from '../edit-contact/edit-contact.component';
import { DeleteContactComponent } from '../delete-contact/delete-contact.component';
import { hasTag } from '../../util/tag-utils';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  @Input() business: Business;
  editModeSet = false;
  isAmbassador = false;
  isRegionalManager = false;

  constructor(private _toggleService: EditToggleService,
              private _editContactDialog: MatDialog,
              private _deleteContactDialog: MatDialog,
              private _snackBar: MatSnackBar,
              private _businessManagerService: BusinessManagerService) {}

  async ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => this.editModeSet = isOn);
    if (hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub) {
      this.isAmbassador = await this._businessManagerService.isAmbassador();
    }
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  deleteContact(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      businessID: this.business.id,
      contactID: this.business.contacts[index].id
    };
    const dialogRef = this._deleteContactDialog.open(DeleteContactComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this._snackBar.open('Contact Info', 'Deleted', {
          duration: 2000
        });
        this.business.contacts.splice(index, 1);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  openEditContactDialog(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      businessID: this.business.id,
      contactID: null,
      isNew: false
    };
    index == null ? dialogConfig.data.isNew = true : dialogConfig.data.contact = this.business.contacts[index];
    dialogConfig.data['busID'] = this.business.id;
    dialogConfig.width = '60%';
    const dialogRef = this._editContactDialog.open(EditContactComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        if (isUpdated.isNew) {
          this.business.contacts.push(isUpdated.contact);
          this._snackBar.open('Contact Info', 'Added', {
            duration: 2000
          });
        } else {
          this._snackBar.open('Contact Info', 'Updated', {
            duration: 2000
          });
        }
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
